module.exports = __webpack_public_path__ + "packs/media/images/Matchen-874d23747d4c4a2385f3506b218435a2.svg";